import React, { useEffect, useState } from 'react'
import { Card, Col, Modal, notification, Row, Select, Button, Table, Typography } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateEventStatusByVenueId, filterEventsByVenueId } from '~actions'
import { getCurrentUser } from '~context'

import { MultiSelect, PageLayout, Spinner } from '~stories'

import './BulkEventPublisher.modules.css'

const { Text } = Typography

const PAGE_TITLE = 'Event Bulk Updates'
const { Option } = Select

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const BulkEventPublisher = ({
  allVenues: allVenuesProps,
  filterEventsByVenueId,
  updateEventStatusByVenueId,
  publishedEvents: publishedEventsProps,
  unPublishedEvents: unPublishedEventsProps,
  message,
  success
}) => {
  const [selectedVenue, setSelectedVenue] = useState()
  const [selectedVenueIndex, setSelectedVenueIndex] = useState()
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()
  const [isDataLoaded, setIsDataLoaded] = useState()
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const [publishedEvents, setPublishedEvents] = useState()
  const [unPublishedEvents, setUnPublishedEvents] = useState()
  const [initialPublishedIds, setInitialPublishedIds] = useState([])
  const [initialUnPublishedIds, setInitialUnPublishedIds] = useState([])

  useEffect(() => {
    if (publishedEventsProps) {
      setIsDataLoaded(true)
      setPublishedEvents(publishedEventsProps)
      setInitialPublishedIds(publishedEventsProps.map(e => e?.id || e?._id))
    }
  }, [publishedEventsProps])

  useEffect(() => {
    if (unPublishedEventsProps) {
      setUnPublishedEvents(unPublishedEventsProps)
      setInitialUnPublishedIds(unPublishedEventsProps.map(e => e?.id || e?._id))
    }
  }, [unPublishedEventsProps])

  const newlyPublished = publishedEvents?.filter(e => {
    const id = e?.id || e?._id
    return initialUnPublishedIds.includes(id)
  }) || []

  const newlyUnPublished = unPublishedEvents?.filter(e => {
    const id = e?.id || e?._id
    return initialPublishedIds.includes(id)
  }) || []

  const hasChanges = newlyPublished.length > 0 || newlyUnPublished.length > 0

  const onSubmitHandler = (event) => {
    event.preventDefault()
    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }
    setShowConfirmModal(true)
  }

  const handleConfirmUpdate = () => {
    setShowConfirmModal(false)
    setIsDataLoaded(false)
    const publishedEventIds = publishedEvents.map(event => event?.id)
    const unPublishedEventIds = unPublishedEvents.map(event => event?.id)
    updateEventStatusByVenueId(selectedVenue?.value, { publishedEventIds, unPublishedEventIds }, accessToken)
  }

  useEffect(() => {
    if (success) {
      setIsDataLoaded(true)
      const totalChanged = newlyPublished.length + newlyUnPublished.length
      notification.success({
        message: `Bulk publish complete — ${totalChanged} event${totalChanged !== 1 ? 's' : ''} updated`,
        description: [
          newlyPublished.length > 0 ? `${newlyPublished.length} published` : '',
          newlyUnPublished.length > 0 ? `${newlyUnPublished.length} unpublished` : ''
        ].filter(Boolean).join(', ')
      })
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    } else if (!success && message) {
      notification.error({ message: message })
    }
  }, [success, message, newlyPublished.length, newlyUnPublished.length])

  const managePageLists = (items, source, dest, sourceFn, destFn) => {
    const selectedItems = Array.isArray(items)
      ? items
      : [items]
    const clonedSource = [...source]
    let clonedDest = [...dest]
    selectedItems.forEach(item => {
      const selectedEventIndex = clonedSource.findIndex(event => event?.title === item?.title)
      const [itemToMove] = clonedSource.splice(selectedEventIndex, 1)
      clonedDest = [...clonedDest, itemToMove]
    })
    sourceFn([...clonedSource])
    destFn([...clonedDest])
  }

  const onListAdd = (selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents) => {
    managePageLists(selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents)
  }

  const onListRemove = (selectedEvent, allEvents, selectedEvents, setallEvents, setSelectedEvents) => {
    managePageLists(selectedEvent, selectedEvents, allEvents, setSelectedEvents, setallEvents)
  }

  const onListFilter = (allListItems, filterValue) => {
    const testRegExp = new RegExp(filterValue, 'i')
    return allListItems.filter(item => {
      const title = `${item?.title}`
      return testRegExp.test(title)
    })
  }

  return (
    <PageLayout title={PAGE_TITLE}>
      <form noValidate onSubmit={(event) => onSubmitHandler(event)}>

        <div className="form-flag-row">
          <Select
            allowClear
            onChange={(value) => {
              const venueId = allVenuesProps[value] ? allVenuesProps[value].value : null
              setSelectedVenue(allVenuesProps[value])
              setSelectedVenueIndex(value)
              if (venueId) {
                setIsDataLoaded(false)
                filterEventsByVenueId({ venueId })
              }
            }}
            onClear={() => {
              setSelectedVenue()
              setSelectedVenueIndex(-1)
            }}
            placeholder='Select Venue'
            style={{ width: '300px' }}
            value={selectedVenueIndex}
          >
            {
              allVenuesProps?.map((venueLogo, index) => <Option key={index} value={index}>{venueLogo.label}</Option>)
            }
          </Select>
          <br />
          <br />
          <Card title="">
            <Row>
              <Col span={16}>
                { selectedVenue?.value &&
                  <>
                    {isDataLoaded ? <MultiSelect
                      availableListHeaderString='UnPublished Events'
                      availableListItems={unPublishedEvents}
                      displayField="title"
                      onAdd={(items) => onListAdd(items, unPublishedEvents, publishedEvents, setUnPublishedEvents, setPublishedEvents)}
                      onFilter={onListFilter}
                      onRemove={(items) => onListRemove(items, unPublishedEvents, publishedEvents, setUnPublishedEvents, setPublishedEvents)}
                      selectedListHeaderString='Published Events'
                      selectedListItems={publishedEvents}
                      valueField='_id'
                    /> : <Spinner isLoading />}
                  </>
                }
              </Col>
            </Row>
          </Card>
        </div>
        <div className="form-row">
          <Button disabled={!selectedVenue || !hasChanges} htmlType='submit' type="primary">
            Update
          </Button>
        </div>
      </form>

      <Modal
        cancelText="Cancel"
        okText="Proceed"
        onCancel={() => setShowConfirmModal(false)}
        onOk={handleConfirmUpdate}
        title="Confirm Bulk Event Update"
        visible={showConfirmModal}
        width={700}
      >
        {newlyPublished.length > 0 && (
          <>
            <Text strong style={{ display: 'block', marginBottom: 12 }}>
              Moved to PUBLISHED: ({newlyPublished.length})
            </Text>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: 4, marginBottom: 16 }}>
              <Table
                bordered
                columns={[{
                  dataIndex: 'title',
                  render: (text, record) => (
                    <a href={`/events/${record?.tmEventId}`} rel="noopener noreferrer" target="_blank">
                      {text}
                    </a>
                  )
                }]}
                dataSource={newlyPublished}
                footer={() => newlyPublished.length > 4 ? <Text type="secondary">↕ Scroll to see all {newlyPublished.length} events</Text> : null}
                pagination={false}
                rowKey={(record) => record?.tmEventId}
                scroll={{ y: 150 }}
                showHeader={false}
                size="small"
              />
            </div>
          </>
        )}
        {newlyUnPublished.length > 0 && (
          <>
            <Text strong style={{ display: 'block', marginBottom: 12 }}>
              Moved to UNPUBLISHED: ({newlyUnPublished.length})
            </Text>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: 4, marginBottom: 20 }}>
              <Table
                bordered
                columns={[{
                  dataIndex: 'title',
                  render: (text, record) => (
                    <a href={`/events/${record?.id || record?._id}/edit`} rel="noopener noreferrer" target="_blank">
                      {text}
                    </a>
                  )
                }]}
                dataSource={newlyUnPublished}
                footer={() => newlyUnPublished.length > 4 ? <Text type="secondary">↕ Scroll to see all {newlyUnPublished.length} events</Text> : null}
                pagination={false}
                rowKey={(record, i) => record?.id || record?._id || i}
                scroll={{ y: 150 }}
                showHeader={false}
                size="small"
              />
            </div>
          </>
        )}

        <Text type="warning">
          Are you sure you want to proceed with these changes?
        </Text>
      </Modal>
    </PageLayout>
  )
}

const mapStateToProps = ({ dashboard, eventsUpdate }) => ({
  allVenues: dashboard.allVenues,
  publishedEvents: eventsUpdate?.publishedEvents,
  unPublishedEvents: eventsUpdate?.unPublishedEvents,
  message: eventsUpdate.message,
  success: eventsUpdate.success
})

const mapDispatchToProps = {
  updateEventStatusByVenueId,
  filterEventsByVenueId
}

BulkEventPublisher.propTypes = {
  allVenues: PropTypes.array,
  filterEventsByVenueId: PropTypes.func,
  message: PropTypes.string,
  publishedEvents: PropTypes.array,
  success: PropTypes.bool,
  unPublishedEvents: PropTypes.array,
  updateEventStatusByVenueId: PropTypes.func
}

BulkEventPublisher.defaultProps = {

}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkEventPublisher)
